import { render } from "./Past24.vue?vue&type=template&id=114c9efd"
import script from "./Past24.vue?vue&type=script&lang=js"
export * from "./Past24.vue?vue&type=script&lang=js"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__